export const SILVER_LOYALTY_INDICATION_POINTS = 1600;
